/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceDto } from './InvoiceDto';
import {
    InvoiceDtoFromJSON,
    InvoiceDtoFromJSONTyped,
    InvoiceDtoToJSON,
    InvoiceDtoToJSONTyped,
} from './InvoiceDto';

/**
 * 
 * @export
 * @interface InvoiceDtoPagedResponseDto
 */
export interface InvoiceDtoPagedResponseDto {
    /**
     * 
     * @type {Array<InvoiceDto>}
     * @memberof InvoiceDtoPagedResponseDto
     */
    items?: Array<InvoiceDto> | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDtoPagedResponseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDtoPagedResponseDto
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDtoPagedResponseDto
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the InvoiceDtoPagedResponseDto interface.
 */
export function instanceOfInvoiceDtoPagedResponseDto(value: object): value is InvoiceDtoPagedResponseDto {
    return true;
}

export function InvoiceDtoPagedResponseDtoFromJSON(json: any): InvoiceDtoPagedResponseDto {
    return InvoiceDtoPagedResponseDtoFromJSONTyped(json, false);
}

export function InvoiceDtoPagedResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceDtoPagedResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(InvoiceDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function InvoiceDtoPagedResponseDtoToJSON(json: any): InvoiceDtoPagedResponseDto {
    return InvoiceDtoPagedResponseDtoToJSONTyped(json, false);
}

export function InvoiceDtoPagedResponseDtoToJSONTyped(value?: InvoiceDtoPagedResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(InvoiceDtoToJSON)),
        'totalCount': value['totalCount'],
        'pageIndex': value['pageIndex'],
        'pageSize': value['pageSize'],
    };
}

